import React from 'react';
import { useHistory } from 'react-router-dom';
import { IQuestionnaireFormValues } from '../form';
import { Container } from 'react-bootstrap';
import { FormHeading } from '../../../form/formHeading';
import { Form, Well } from '../../../form';
import QuestionnaireForm from '../form';
import SectionFactory from '../form/SectionFactory';
import createQuestionnaire from './createQuestionnaire';
import schema from '../form/schema';

const initialValues: IQuestionnaireFormValues = {
  name: '',
  sections: [SectionFactory.Create()],
};

export const CreateQuestionnairePage: React.FC = () => {
  const history = useHistory();

  return (
    <Container fluid>
      <Well>
        <FormHeading
          title="Questionnaire"
          subTitle="Create"
          backPath="/admin/questionnaires"
        />
        <Form
          initialValues={initialValues}
          promise={createQuestionnaire}
          validationSchema={schema}
          onSubmit={() => history.push('/admin/questionnaires')}
        >
          <QuestionnaireForm />
        </Form>
      </Well>
    </Container>
  );
};
